import React from 'react';
import { IconQuestionCircle } from '@arco-design/web-react/icon';
import { Tooltip } from '@bay-email/editor';

interface HelpProps {
	title: React.ReactNode;
	style?: Partial<React.CSSProperties>;
	placement?: string;
	overlayClassName?: string;
}

export function Help(props: HelpProps) {
	const rawFontSize = props.style?.fontSize;
	const parsedFontSize =
		typeof rawFontSize === 'number'
			? rawFontSize
			: rawFontSize
				? Number.parseInt(String(rawFontSize), 10)
				: NaN;
	const iconSize =
		Number.isFinite(parsedFontSize) && parsedFontSize > 0 ? parsedFontSize : 14;

	return (
		<Tooltip
			content={props.title}
			placement={props.placement}
			overlayClassName={props.overlayClassName}
		>
			<button
				type='button'
				onClick={event => {
					event.preventDefault();
					event.stopPropagation();
				}}
				style={{
					cursor: 'pointer',
					background: 'transparent',
					border: 'none',
					padding: 0,
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: iconSize,
					height: iconSize,
					lineHeight: 1,
					flex: '0 0 auto',
				}}
			>
				<IconQuestionCircle style={props.style} />
			</button>
		</Tooltip>
	);
}
